export function canRenderImageType(type) {
  const canvas = document.createElement('canvas')
  return canvas.toDataURL(type).indexOf(`data:${type}`) === 0
}
